import React, { useState } from 'react'
import { User } from '../Shared/common_defs'
import { defs } from '../Shared/defs'
import { BoxProps, Text, Flex, Button } from '@workwhile/ui'

type UserHeaderProps = BoxProps & {
  user: User
}

const UserHeader = ({ user, ...boxProps }: UserHeaderProps) => {
  const [copied, _setCopied] = useState(false)

  const wasCopied = () => {
    _setCopied(true)
    setTimeout(() => _setCopied(false), 1000)
  }

  const copyToClipboard = (
    str: string,
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.stopPropagation()
    const textArea = document.createElement('textarea')
    textArea.value = str
    // make the textarea out of viewport
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    return new Promise(() => {
      const successful = document.execCommand('copy')
      if (successful) {
        wasCopied()
      }
      textArea.remove()
    })
  }

  return (
    <Flex gap={3} alignItems="center">
      <Text
        as="a"
        href={`https://console.cloud.google.com/logs/query;query=resource.type%3D"gae_app" log_name%3D"projects%2Fworkwhile-247820%2Flogs%2Flib.observability.structured" jsonPayload.message.type%3D"app_request_log" jsonPayload.message.user_id%3D${user.id};timeRange=PT24H;summaryFields=jsonPayload%2Fmessage%2Fstatus_code,jsonPayload%2Fmessage%2Fmethod,jsonPayload%2Fmessage%2Fpath:false:32:beginning?project=workwhile-247820&folder=true&organizationId=136924707921&query=`}
        target="_blank"
        fontWeight={2}
        fontSize={3}
      >
        {user.name}
      </Text>
      •
      <Flex style={{ color: defs.mediumBlack }} alignItems="center">
        <Text
          as="a"
          data-context-key="user_id"
          data-context-value={user.id}
          data-context-label={user.name}
          href={`https://app.intercom.com/apps/ozmz3fh8/users/show?user_id=${user.id}`}
          target="_blank"
          rel="noreferrer"
        >
          {user.id}
        </Text>
        <Button
          style={copyButtonStyle}
          onClick={(e) => copyToClipboard(user.id ?? '', e)}
          kind="small"
          variant="secondary"
        >
          Copy
        </Button>
      </Flex>
      •
      <Flex style={{ color: defs.mediumBlack }} alignItems="center">
        <Text
          as="a"
          href={`https://analytics.amplitude.com/workwhile/project/241707/search/user_id%3D${user.firebaseId}`}
          target="_blank"
          rel="noreferrer"
        >
          {user.firebaseId}
        </Text>
        <Button
          style={copyButtonStyle}
          onClick={(e) => copyToClipboard(user.firebaseId ?? '', e)}
          variant="secondary"
          kind="small"
        >
          Copy
        </Button>
      </Flex>
      {copied ? (
        <span style={{ color: defs.darkAlertGreen }}>Copied!</span>
      ) : null}
    </Flex>
  )
}

const copyButtonStyle = {
  marginLeft: 14,
  borderColor: defs.mediumBlack,
  borderWidth: 1,
  backgroundColor: defs.white,
  borderRadius: defs.borderRadiusM,
  fontSize: 12,
}

export default UserHeader
